import { defineMessages } from 'react-intl';

export const childRunInlinePanelMessages = defineMessages({
  stop: {
    defaultMessage: 'Stop',
    id: '+OLFsARgvq',
    description: 'Button on a delegate row that cancels the in-flight child agent run',
  },
  stopping: {
    defaultMessage: 'Stopping',
    id: 'W9Xm6wrXkA',
    description:
      'Disabled state of the Stop button while the child agent run cancellation is in flight',
  },
  defaultAgentName: {
    defaultMessage: 'Agent',
    id: 'WCdbi51qII',
    description: 'Fallback child-run panel title when the agent name is unknown',
  },
  starting: {
    defaultMessage: 'Starting…',
    id: 'o2VMFsHvjg',
    description: 'Child-run status while waiting for the run id',
  },
  working: {
    defaultMessage: 'Working…',
    id: 'nQMbFTnfcB',
    description: 'Child-run status while the agent is executing',
  },
  failed: {
    defaultMessage: 'Failed',
    id: '+mF5lYvnO9',
    description: 'Child-run status when the run errored',
  },
  cancelled: {
    defaultMessage: 'Canceled',
    id: 'LJaks1rh8R',
    description: 'Child-run status when the run was canceled',
  },
  done: {
    defaultMessage: 'Done',
    id: 'HH2vY6sFqJ',
    description: 'Child-run status when the run completed',
  },
  openRun: {
    defaultMessage: 'Open run',
    id: 'ujGD6MPTCo',
    description: 'Link to open a child agent run in a new tab',
  },
  hide: {
    defaultMessage: 'Hide',
    id: '/AKbxttIl5',
    description: 'Collapse child-run inline panel details',
  },
  show: {
    defaultMessage: 'Show',
    id: 'IzyKr1/lK8',
    description: 'Expand child-run inline panel details',
  },
  runUnavailable: {
    defaultMessage: 'This run could not be loaded.',
    id: '2A5gPekZ8y',
    description: 'Child-run panel when the run snapshot failed to load',
  },
  openingRunSkeleton: {
    defaultMessage: 'Opening run',
    id: 'Jkijmj3SPm',
    description: 'Accessible label on the child-run loading skeleton',
  },
});
